//from here
//https://stackoverflow.com/questions/26336585/three-js-webgl-x-ray-effect/26356616
uniform vec3 glowColor;
        varying float intensity;
        void main()
        {
            vec3 glow = glowColor * intensity;
            gl_FragColor = vec4( glow * intensity, intensity );
        }